export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./request.vue?vue&type=template&id=562b044a&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/request.vue?vue&type=template&id=562b044a&
// module id = 1354
// module chunks = 0